import { EntityKind } from 'mdello-client-ts/dist/src/interfaces/admin/entity.interface';
import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { getClient } from 'src/util/mdello-instance';
import { BoxResponseData } from './interfaces/box.interface';

const fetchBox = async (boxId: string): Promise<BoxResponseData | undefined> => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  const data: BoxResponseData | undefined = await getClient()?.getEntity(
    {
      kind: EntityKind.BOX,
      projectId: currentProject._id
    },
    boxId
  );

  return data;
};

export const useGetBox = (boxId: string) => {
  const { notify } = useNotification();

  return useQuery([QueryKey.BOX_DETAILS, boxId], () => fetchBox(boxId), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    }
  });
};
